module.exports = __webpack_public_path__ + "ff87b69ce2fb02a3e1ea41cc079cba2a.png";